import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ImportApiObjectsService } from 'src/app/Services/import-api-objects.service';
import { ProjectService } from 'src/app/Services/project.service'
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'app-import-api-objects',
  templateUrl: './import-api-objects.component.html',
  styleUrls: ['./import-api-objects.component.scss']
})
export class ImportApiObjectsComponent implements OnInit {
  projectId: string | null = null;
  projectIdDb2: string | null = null;
  selectedFiles: File[] = [];
  createStep: boolean = false;
  stepName: string = '';
     
  constructor(
    private sharedService: SharedService,
    private importApiObjectsService: ImportApiObjectsService,
    private projectService: ProjectService, 
    private notifys: NotifyService,
    private dialogRef: MatDialogRef<ImportApiObjectsComponent>,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.projectId = localStorage.getItem('projectId');
    this.projectIdDb2 = localStorage.getItem('projectIdDb2');
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
       
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      this.selectedFiles = [selectedFile];
      input.value = '';
      this.updateStepName();
    }
  }
  
  removeFile(fileToRemove: File): void {
    this.selectedFiles = this.selectedFiles.filter(file => file !== fileToRemove);
    if (this.selectedFiles.length === 0) {
      this.stepName = '';
    }
  }

  clearFiles(): void {
    this.selectedFiles = [];
    this.stepName = '';
  }

  onCreateStepChange(event: any): void {
    this.createStep = event.checked;
    
    if (!this.createStep) {
      this.stepName = '';
    } else {
      // If checkbox is checked, set step name from selected file
      this.updateStepName();
    }
    
    this.cdr.detectChanges(); // Ensure UI updates
  }

  updateStepName(): void {
  if (this.selectedFiles.length > 0) {
    const fileName = this.selectedFiles[0].name;
    this.stepName = fileName
      .replace(/\.json$/i, '')
      .replace(/[^a-zA-Z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    console.log('Step name set to:', this.stepName);
    this.cdr.detectChanges();
  }
}

  onSubmit(): void {
    if (this.selectedFiles.length === 0) {
      this.notifys.notify("error", "Error", "Please select a file to import");
      return;
    }
    if (this.createStep && !this.stepName.trim()) {
      this.notifys.notify("error", "Error", "Please enter a step name");
      return;
    }
    // Check step name availability if createStep is true
    if (this.createStep) {
      this.sharedService.loaderHide.emit(true);
      this.projectService.isStepNameAvailable(this.projectIdDb2,this.stepName.trim()).subscribe({
        next: (isAvailable) => {
          this.sharedService.loaderHide.emit(false);
          if (!isAvailable) {
            this.proceedWithFileUpload();
          } else {
            this.notifys.notify("error", "Error", "Step name already exists");
            return;
          }
        },
        error: (error) => {
          this.sharedService.loaderHide.emit(false);
          this.notifys.notify("error", "Error", "Failed to validate step name");
        }
      });
    } else {
      this.proceedWithFileUpload();
    }
  }
  
  private proceedWithFileUpload(): void {
    this.sharedService.loaderHide.emit(true);
    this.selectedFiles.forEach(file => {
      this.importApiObjectsService.uploadApiObjectFile(
        file, 
        this.projectId, 
        this.projectIdDb2, 
        this.createStep, 
        this.stepName
      ).subscribe({
        next: (response) => {
          this.sharedService.loaderHide.emit(false);
          if (response.operationMessage === "Invalid file format: Missing 'info' section"){
            this.notifys.notify("error", "Error", "invalid file format");
          } else if(response.operationMessage === "Only JSON and Postman collection files are allowed."){
            this.notifys.notify("error", "Error", "invalid file format");
          } else if(response.operationStatus === "ERROR"){
            this.notifys.notify("error", "Error", "Failed to import Api Objects");
          } else {
            this.notifys.notify("success", "Success", "Api Objects imported successfully");
          }
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.sharedService.loaderHide.emit(false);
          this.notifys.notify("error", "Error", "Failed to import Api Objects");

        }
      });
    });
  }
     
  onCancel(): void {
    this.selectedFiles = [];
    console.log('Import cancelled');
    this.dialogRef.close(); // Close dialog without passing any result
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}